import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { DirectionService } from '@spartacus/storefront';
import { provideDefaultConfig } from '../../core/config';
import { defaultDirectionConfig } from './config/default-direction.config';

export function initHtmlDirAttribute(directionService: DirectionService): () => Promise<void> {
  return () => directionService.initialize();
}

/**
 * Provides a configuration and APP_INITIALIZER to add the correct (language drive) html direction.
 */
@NgModule({
  providers: [
    provideAppInitializer(() => {
      const initializerFn = initHtmlDirAttribute(inject(DirectionService));
      return initializerFn();
    }),
    provideDefaultConfig(defaultDirectionConfig),
  ],
})
export class DirectionModule {}
